import React from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import OverviewSection from './OverviewSection';
import ScheduleSection from './ScheduleSection';
import PatientsSection from './PatientsSection';
import FinancialSection from './FinancialSection';
import LeadsSection from './LeadsSection';
import SatisfactionSection from './SatisfactionSection';

/**
 * Seções das estatísticas, na ordem da tela e do PDF. `id` é o nome da seção
 * na API (statistics/get.php?section=) e a âncora do menu lateral.
 */
const STATS_SECTION_LIST = [
  {
    id: 'overview',
    label: 'Resumo',
    description: 'O principal do período e o que pede atenção',
    icon: <DashboardOutlinedIcon />,
    accent: 'blue',
    Component: OverviewSection,
  },
  {
    id: 'schedule',
    label: 'Agenda',
    description: 'Atendimentos, faltas e horários mais procurados',
    icon: <CalendarMonthOutlinedIcon />,
    accent: 'purple',
    Component: ScheduleSection,
  },
  {
    id: 'patients',
    label: 'Pacientes',
    description: 'Quem chegou, quem voltou e quem parou de vir',
    icon: <PeopleAltOutlinedIcon />,
    accent: 'teal',
    Component: PatientsSection,
  },
  {
    id: 'financial',
    label: 'Financeiro',
    description: 'Recebido, despesas, resultado e o que falta receber',
    icon: <AccountBalanceWalletOutlinedIcon />,
    accent: 'green',
    Component: FinancialSection,
  },
  {
    id: 'leads',
    label: 'Leads',
    description: 'Contatos recebidos e quantos viraram pacientes',
    icon: <CampaignOutlinedIcon />,
    accent: 'pink',
    Component: LeadsSection,
  },
  {
    id: 'satisfaction',
    label: 'Satisfação',
    description: 'NPS, notas e o que os pacientes escreveram',
    icon: <SentimentSatisfiedAltOutlinedIcon />,
    accent: 'amber',
    Component: SatisfactionSection,
  },
];

export default STATS_SECTION_LIST;
